"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iDom = require("@wk/incremental-dom");
iDom.attributes.value = function (el, name, value) {
    // `input.value = undefined` converts undefined to string
    var prop = value === undefined ? null : value;
    iDom.applyProp(el, name, prop);
    iDom.applyAttr(el, name, value);
};
iDom.attributes.disabled = iDom.attributes.checked = function (el, name, value) {
    // for boolean attrs idom passes values as '' for true and undefined for false
    var newValue = value === '' ? true : false;
    iDom.applyProp(el, name, newValue);
    iDom.applyAttr(el, name, value);
};
